import Vue from 'vue/dist/vue.esm.js'
import { map, filter } from 'underscore'
import Select2Mixin from '../mixins/select2_mixin.js.coffee'

Vue.component('report-document-group-select',
  template: JST['report_document_groups/select']()
  props: ['groups', 'initialSelectedGroupId']
  data: ->
    selected: @initialSelectedGroupId
  computed:
    options: ->
      JSON.parse(@groups)
    collection: ->
      @options.map( (opt) -> [opt.name, opt.id])
    selectedGroup: ->
      @options.filter( (option) =>
        option.id.toString() == @selected
      )[0]
  watch:
    selected: ->
      @$emit('group-changed', @selectedGroup)
  components:
    groupSelect: Select2Mixin
)
